import type { TooltipContentProps } from 'recharts'
import type { WeeklyGmvChartDataPoint } from './weekly-gmv-chart-data-point'
import { useFormatAmount } from 'core/hooks/useFormatAmount'

type WeeklyGmvChartTooltipProps = TooltipContentProps<number, string> & {
  currency: string
  realizedTrajectoryLabel: string
  forecastTrajectoryLabel: string
  probableTrajectoryLabel: string
}

const WeeklyGmvChartTooltip = ({
  active,
  payload,
  currency,
  realizedTrajectoryLabel,
  forecastTrajectoryLabel,
  probableTrajectoryLabel
}: WeeklyGmvChartTooltipProps) => {
  const formatAmount = useFormatAmount()
  if (!active || !payload?.length) return null

  const point = payload[0]?.payload as WeeklyGmvChartDataPoint | undefined
  if (!point) return null

  const gmv = point.realizedGmv ?? point.forecastGmv
  const forecastOrProbableTrajectoryLabel = point.isCurrentWeek ? probableTrajectoryLabel : forecastTrajectoryLabel
  const caption = point.realizedGmv === null ? forecastOrProbableTrajectoryLabel : realizedTrajectoryLabel

  return (
    <div className="mg-weekly-gmv-chart-tooltip">
      <p className="mg-weekly-gmv-chart-tooltip-value vp-body-s">
        {formatAmount(gmv, currency)} / {formatAmount(point.trajectoryGmv, currency)}
      </p>
      <p className="mg-weekly-gmv-chart-tooltip-label vp-caption">{caption}</p>
    </div>
  )
}

export default WeeklyGmvChartTooltip
